<template>
	<div :class="['nk-badge', this.type, this.modelValue, this.tag]">
		<icon v-if="type !== 'state'" icon="angle-left" class="badge-angle-icon" />
		<span v-html="badgeTitle"></span>
	</div>
</template>

<script>
	export default {
		props: {
			type: { type: String, required: true },
			modelValue: { type: String, required: true },
			tag: { type: String, required: false },
			title: { type: String, required: false }
		},
		data() {
			return {}
		},
		computed: {
			badgeTitle() {
				if (this.title && this.title !== '') {
					return this.title
				} else {
					let name = `badges.${this.type}.${this.modelValue}`
					if (this.tag && this.tag !== '') {
						name += `.${this.tag}`
					}

					return this.$t(name)
				}
			}
		},
		created() { },
		mounted() { },
		methods: {},
	}
</script>

<style>
	.badge-angle-icon {
		font-size: 14px;
		font-weight: 400;
		position: absolute;
		top: 3px;
		right: -12px;
	}
</style>
